import { RequestServerClass } from '../../util/request';
import publishObjectPath from '@/util/configRegistry';
import { changePostParam } from '@/util/changePostParam';

const serverUrl = publishObjectPath.serverUrl;
const qs = require('qs');
const conttype = 'application/x-www-form-urlencoded';

export class UserServe {
  public rSerivce: any;

  constructor(opt: any, axiosFilterFn?: any) {
    this.rSerivce = new RequestServerClass(opt);
    axiosFilterFn.call(this, this.rSerivce.serverObj);
  }
  // 所有数据
  public getPageDataAll(opts: object) {
    const url = serverUrl + '/api/spaceManage/spaceStaff/all';
    return this.rSerivce.serverObj.get(url, {
      params: opts,
    });
  }

  // 获取分页数据
  public getPageData(opts: object) {
    const url = serverUrl + '/api/spaceManage/spaceStaff';
    return this.rSerivce.serverObj.get(url, {
      params: opts,
    });
  }

  // 删除用户
  public deleteData(id: string) {
    const url = serverUrl + '/api/spaceManage/spaceStaff';
    return this.rSerivce.serverObj.delete(url, {
      params: { idList: id },
    });
  }

  // 新增数据
  public addUserData(opts: object) {
    const url = serverUrl + '/api/spaceManage/spaceStaff';
    return this.rSerivce.serverObj.post(url, opts);
  }

  // 修改数据
  public editUserData(opts: object) {
    const url = serverUrl + '/api/spaceManage/spaceStaff';
    return this.rSerivce.serverObj.put(url, opts);
  }

  //  获取当前人员的组织结构树
  public getCurrentOrgTree(opts: object) {
    const url = serverUrl + '/api/spaceManage/spaceStaff/getCurrentOrgTree';
    return this.rSerivce.serverObj.get(url, {
      params: opts,
    });
  }

  // 手动指定组织机构
  public manualOrgTree(opts: object) {
    const url = serverUrl + '/api/spaceManage/spaceStaff/manualSpecifyOrg';
    return this.rSerivce.serverObj.post(url, opts);
  }

  //  获取手动指定组织机构
  public getManualSpecifyOrg(opts: object) {
    const url = serverUrl + '/api/spaceManage/spaceStaff/getManualSpecifyOrg';
    return this.rSerivce.serverObj.get(url, {
      params: opts,
    });
  }
  /**
   * 部门、人员新接口
   * */
  public getStaffOfDept(opts: object) {
    const url = serverUrl + '/api/spaceManage/spaceStaff/all/staff/dept/combination';
    return this.rSerivce.serverObj.get(url, {
      params: opts,
    });
  }
}
